export default 'data:img/jpg;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAAAQCAYAAADwMZRfAAAAIElEQVQ4T2NkoAJgpIIZDKOGYIbiaJiMhgkxeWvwpBMAKPgAEQSMpkEAAAAASUVORK5CYII='
